import type { Boundary } from '@/types/diagram';

/** IDs of every boundary nested (at any depth) under `boundaryId`. */
export function getBoundaryDescendantIds(boundaries: Boundary[], boundaryId: number): Set<number> {
  const children = new Map<number, number[]>();
  for (const b of boundaries) {
    if (b.parent_boundary_id == null) continue;
    const siblings = children.get(b.parent_boundary_id) ?? [];
    siblings.push(b.id);
    children.set(b.parent_boundary_id, siblings);
  }

  const descendants = new Set<number>();
  const stack = [...(children.get(boundaryId) ?? [])];
  while (stack.length > 0) {
    const current = stack.pop()!;
    if (current === boundaryId || descendants.has(current)) continue;
    descendants.add(current);
    stack.push(...(children.get(current) ?? []));
  }
  return descendants;
}

/** Boundaries that can be chosen as parent of `boundaryId` without creating a cycle. */
export function getPossibleParentBoundaries(boundaries: Boundary[], boundaryId: number): Boundary[] {
  const excluded = getBoundaryDescendantIds(boundaries, boundaryId);
  excluded.add(boundaryId);
  return boundaries.filter((b) => !excluded.has(b.id));
}
